import {
  createTrackingConsentManager,
  type EffectiveTrackingConsentPolicy,
  type TrackingConsentManager,
  type TrackingConsentScope
} from '@goldcast/tracking-consent';

import '@goldcast/tracking-consent/styles.css';

let manager: TrackingConsentManager | null = null;

/**
 * Builds the shared consent manager from the effective event policy.
 * Returns null when the flag is off, the org has not enabled consent, or the
 * scope ID is missing — in those cases tracking runs without a gate, matching
 * pre-GDPR-feature behaviour.
 */
export function initializeTrackingConsent(
  policy: EffectiveTrackingConsentPolicy | null | undefined,
  scope: TrackingConsentScope
): TrackingConsentManager | null {
  if (new URLSearchParams(window.location.search).get('record_mode') === 'true') {
    manager = null;
    return null;
  }
  if (!policy || policy.enabled !== true || !scope?.id) {
    manager = null;
    return null;
  }
  manager = createTrackingConsentManager({ policy, scope, document, location });
  manager.mountBanner();
  return manager;
}

/** Whether non-essential tracking may run now. Defaults to true when no consent manager is active (flag off or org not configured). */
export function canEmitTracking(): boolean {
  return manager ? manager.canTrack() : true;
}

export function getTrackingConsentManager(): TrackingConsentManager | null {
  return manager;
}
